export default "__VITE_ASSET__DDDbwKIv__"